import { withFormik } from 'formik'
import moment from 'moment'
import React, { useState, useEffect, useRef } from 'react'
import { toISODateString } from 'react-dates'
import { object, string } from 'yup'
import { Time } from '../../assets/svg/hartu'
import Button from '../../atoms/Button/Button'
import FormError from '../../atoms/FormError/FormError'
import FormGroup from '../../atoms/FormGroup/FormGroup'
import DatePickerRange from '../../components/DatePickerRange/DatePickerRange'
import DatePicker from '../../components/DatePicker/DatePicker'
import STATES from '../../constants/states'
import t from '../../i18n/translations/translations'
import './HartuBookingDateForm.css'
import HartuTimeSelect from '../../components/Hartu/HartuTimeSelect/HartuTimeSelect'
import HartuTimeSelectMulti from '../../components/Hartu/HartuTimeSelectMulti/HartuTimeSelectMulti'

const HartuBookingDateForm = withFormik({
    displayName: 'HartuBookingDateForm',
    handleSubmit: (values, formikBag) => {
        if (typeof formikBag.props.handleSubmit !== 'function') {
            return
        }
        formikBag.props.handleSubmit(values)
    },
    mapPropsToValues: (props) => ({
        dates: Array.isArray(props.paramsDate)
            ? props.paramsDate
            : props.paramsDate
            ? [props.paramsDate]
            : [],
        lang: props.lang,
    }),
    validationSchema: (props) => {
        const { lang } = props
        return object().shape({
            dates: string().required(t.error_required_date[lang])
        })
    },
})(({
    availableDates,
    availableDaysMessage,
    dateFocused,
    datesLoading,
    errors,
    facilityHoursAvailable,
    getAvailableHours,
    handleCloseConcurrenceError,
    handleSubmitDate,
    lang,
    paramsDate,
    setDayFocused,
    setFieldValue,
    state,
    touched,
    values,
    handleHideDiscount,
    instanceID,
    maxPeople,
    setMaxPeople,
    setDates,
    disabled,
    isTributariaBlocked,
    hasCalendarRange,
    hasCalendarRangeConsecutive
}) => {
    const searchParams = new URLSearchParams(
        window.location.href.split(`?`)[
            window.location.href.split(`?`).length - 1
        ]
    )
    const userId = searchParams.get('sid');
    const token = searchParams.get('uztk'+instanceID);
    
    const [hoursLoading, setHoursLoading] = useState(false)

    if (typeof userId !== 'undefined' && userId !== null) {
        if (typeof token !== 'undefined' && token !== null) {
            sessionStorage.setItem('token', token);
        }

        sessionStorage.setItem('uzky', userId);
        location.replace(window.location.origin + window.location.pathname)
    }
        
    //const [optionSelected, setOptionSelected] = useState(null);

    const handleDateChange = async ( startDate, endDate ) => {
        if (typeof endDate === 'undefined' || endDate === null) {
            endDate = startDate;
        }
        setHoursLoading(true)
        await new Promise(resolve => setTimeout(resolve, 1000))
        await getAvailableHours(startDate, endDate)
        setHoursLoading(false)
    }

    let availableHours = [];
    if (facilityHoursAvailable != null) {
        availableHours = Object.entries(facilityHoursAvailable);
    }

    const hasAvailableDates = !datesLoading && availableDates?.length

   

    let datePlaceholderText

    if (datesLoading) {
        datePlaceholderText = t.loading[lang]
    } else if (hasAvailableDates) {
        datePlaceholderText = t.select_one_day[lang]
    } else {
        datePlaceholderText = t.error_no_available_dates[lang]
    }

    return (
        <form
             className={`hartuBookingDateForm hartuBookingGrid__content--form ${
                isTributariaBlocked ? 'is-disabled' : ''
            }`}
        >
            <div className="hartuBookingDateForm__input--wrapper">
                <FormGroup
                    errors={touched.dates && errors.dates ? errors.dates : null}
                    label={null}
                    required
                >
                    {hasCalendarRange ? (
                        <DatePickerRange
                            selectsRange
                            availableDates={availableDates}
                            dateProp={paramsDate ? moment(paramsDate) : null}
                            datesLoading={datesLoading}
                            disabled={!hasAvailableDates}
                            id="date"
                            lang={lang}
                            onChangedDates={(startDate, endDate ) => {
                                    handleDateChange(startDate, endDate)
                                }
                            }
                            placeholder={datePlaceholderText}
                            required
                            setDayFocused={setDayFocused}
                        />
                    ):(
                        <DatePicker
                            availableDates={availableDates}
                            dateProp={paramsDate ? moment(paramsDate) : null}
                            datesLoading={datesLoading}
                            id="date"
                            lang={lang}
                            placeholder={datePlaceholderText}
                            required
                            setDayFocused={setDayFocused}
                            disabled={!hasAvailableDates || isTributariaBlocked}
                            onChanged={(value) => {
                                if (isTributariaBlocked) return;
                                handleDateChange(value);
                            }}
                        />
                    )}
                    
                </FormGroup>
            </div>

            <div className="server-group__info">
                <p>{availableDaysMessage}</p>
            </div>

            {!dateFocused && (
                <FormGroup
                    className="hartuBookingDateForm__input--wrapper"
                    errors={touched.time && errors.time ? errors.time : null}
                    label={null}
                    required
                >
                    {hasCalendarRange ? (
                        <HartuTimeSelectMulti
                            availableHours={availableHours}
                            disabled={false}
                            hoursLoading={hoursLoading}
                            lang={lang}
                            t={t}
                            onChange={(selectedValues) => {
                                setFieldValue('dates', selectedValues); 
                                setDates(selectedValues);
                            }}
                            maxCapacity={setMaxPeople}
                            hasCalendarRangeConsecutive={hasCalendarRangeConsecutive}
                        />
                    ) : (<HartuTimeSelect
                        availableHours={availableHours}
                        hoursLoading={hoursLoading}
                        disabled={isTributariaBlocked}
                        lang={lang}
                        t={t}
                        onChange={(selectedValues) => {
                            if (isTributariaBlocked) return;
                            setFieldValue('dates', selectedValues); 
                            setDates(selectedValues);
                        }}
                        maxCapacity={setMaxPeople}
                    />)}
                    
                </FormGroup>
            )}

            {!dateFocused && (
                <div className="server-group__info">
                    <p>
                        {t.max_capacity[lang]} {`${maxPeople}`}
                    </p>
                </div>
            )}

            {!dateFocused && (
                <div className="hartuBookingDateForm__submit">
                    <Button
                        onClick={() => handleSubmitDate(values)}
                        disabled={
                            isTributariaBlocked ||
                            !hasAvailableDates ||
                            !values.dates ||
                            values.dates.length === 0
                        }
                    >
                        {t.make_booking[lang]}
                    </Button>
                </div>
            )}
            {state === STATES.ERROR && (
                <FormError className="form-group__errors">
                    {t.error_submit_default[lang]}
                </FormError>
            )}
        </form>
    )
})

export default HartuBookingDateForm
